/**
 * Cloudinary image URL builder
 * Firebase stores only the Cloudinary public ID (e.g. "portfolio/work/YoutubeClone_Preview_ersvjb").
 * This helper converts a public ID into an optimised delivery URL.
 *
 * @param {string} id    - Cloudinary public ID stored in Firebase
 * @param {number} width - Desired output width in pixels
 * @returns {string}     - Full Cloudinary URL with auto format + quality
 */
export const cld = (id, width) =>
  `https://res.cloudinary.com/dc2dtlr4u/image/upload/f_auto,q_auto,w_${width}/${id}`;
